import React from 'react';
import { useEvent } from '@/store';
import Script from 'next/script';

function Gtm() {
  const { event } = useEvent();
  let accounts = [];
  if (event.google_tag_manager) {
    if(event.google_tag_manager.includes(',')) {
      accounts = [...event.google_tag_manager.split(',')];
    } else {
      accounts = [event.google_tag_manager];
    }
  }
  if (process.env.NEXT_PUBLIC_GTM_ID) {
    accounts = [process.env.NEXT_PUBLIC_GTM_ID, ...accounts];
  }
  
  return (
    <>
      {accounts.map((key) => (
        <Script
          id={`google-${key}`}
          key={key}
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${key}');`,
          }}
        ></Script>
      ))}
    </>
  );
}

export default Gtm;
